// Resurser (ADR 0105): hjälpen för byrån, med en rubrik per uppgift. Texten
// ligger i docs/resurser.md, så att den går att läsa och ändra som ett
// dokument, och visas med samma läsare som avtalen.
import { Sida } from '../layout/Sida.js';
import { ankare, Markdown } from './avtal/Markdown.js';
import text from '../../../../docs/resurser.md?raw';

/** Avsnitten, som innehållsförteckningen länkar till. */
export const AVSNITT = [...text.matchAll(/^## (.+)$/gm)].map((m) => m[1] ?? '');

export function Resurser() {
  return (
    <Sida titel="Resurser">
      <div className="resurser">
        <nav className="resurser-innehall" aria-labelledby="resurser-innehall">
          <h2 id="resurser-innehall">Innehåll</h2>
          <ol>
            {AVSNITT.map((rubrik) => (
              <li key={rubrik}>
                <a href={`#${ankare(rubrik)}`}>{rubrik}</a>
              </li>
            ))}
          </ol>
        </nav>
        <div className="resurser-text">
          <Markdown text={text} ankarePaRubriker />
        </div>
      </div>
    </Sida>
  );
}
